import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import {
   Grid,
   TextField,
   Box,
   Typography,
   FormControl,
   InputLabel,
   Select,
   MenuItem,
} from '@mui/material'
import { useEffect, useState } from 'react'
import * as Yup from 'yup'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import ClassicEditor from '../../Utils/RichEditor';
import { useGetLeadsQuery } from '../../Redux/Service/LeadApi'
import { useGetProvidersQuery } from '../../Redux/Service/ProviderApi'
import {
   useCreateEstimationMutation,
   useFindEstimationQuery,
} from '../../Redux/Service/EstimateApi'
import { useGetTechnologyStackListQuery } from '../../Redux/Service/TechnologyStackApi'
import { toast } from 'react-toastify'
import Loading from '../../Components/Loading'
import StyledDashboardLayout from '../style'

function EstimateView() {
   const navigate = useNavigate()
   const [loading, setLoading] = useState(true)
   const { id } = useParams()
   // const [uploadFile, setUploadFile] = useState('Upload Estimate File');
   const {
      data: estimate,
      isLoading: isLoadingForEstimate,
      error: errorForEstimate,
   } = useFindEstimationQuery(id)
   const {
      data: leadData,
      isLoading: isLoadingForLead,
      isError: isErrorForLead,
      error: errorForLead,
   } = useGetLeadsQuery()
   const {
      data: providerData,
      isLoading: isLoadingForProvider,
      isError: isErrorForProvider,
      error: errorForProvider,
   } = useGetProvidersQuery()
   const { data: techData, isLoading: isLoadingForTech } =
      useGetTechnologyStackListQuery()
   const [selectedTechnologies, setSelectedTechnologies] = useState([])
   const [createEstimation] = useCreateEstimationMutation()

   const validationSchema = Yup.object().shape({
      leadId: Yup.number()
         .typeError('Lead ID must be a number')
         .required('Lead ID is required'),
      serviceProviderId: Yup.number()
         .typeError('Service Provider ID must be a number')
         .required('Service Provider ID is required'),
      name: Yup.string().required('Name is required'),
      description: Yup.string().required('Description is required'),
      revisionVersion: Yup.string().required('Revision Version is required'),
      revisionComment: Yup.string().required('Revision Comment is required'),
      totalHours: Yup.number()
         .typeError('Total Hours must be a number')
         .required('Total Hours time in days is required'),
      totalCost: Yup.number()
         .typeError('Total Cost must be a number')
         .required('Total Cost is required'),
      techStack: Yup.array()
         .of(Yup.string().required('Technology is required'))
         .min(1, 'At least one technology is required'),
      file: Yup.mixed().required('File is required'),
   })

   useEffect(() => {
      if (!isLoadingForLead && !isLoadingForProvider && !isLoadingForTech) {
         setSelectedTechnologies(
            techData?.response?.map((tech) => tech.technology),
         )
         setLoading(false)
      }
   }, [
      isLoadingForLead,
      isLoadingForProvider,
      isLoadingForTech,
      isLoadingForEstimate,
      techData,
   ])

   const handleSubmit = async (values) => {
      try {
         let techStackArr = []
         techStackArr = estimate.response.techStack //fuctionality changed
         values.techStack = techStackArr // changed
         values.userId = 1
         values.leadId = parseInt(values.leadId)
         values.serviceProviderId = parseInt(values.serviceProviderId)
         const createEstimationData = await createEstimation(values)

         if (createEstimationData && createEstimationData?.error) {
            toast.error(createEstimationData?.error?.data?.message)
         } else if (createEstimationData) {
            toast.success(createEstimationData.data?.message)
            navigate('/estimate')
         }
      } catch (error) {
         toast.error('Something went wrong, Please try again later!')
         console.error('Login failed', error)
      } finally {
         // setSubmitting(false);
      }
   }

   if (loading) {
      return <Loading />
   }

   return (
      <StyledDashboardLayout>
         <div className="content-wrapper">
            {console.log('techData', techData?.response)}
            <div className="content-header">
               <div className="container-fluid">
                  <div className="d-flex justify-content-between mb-2">
                     <div className="pageTitle">
                        <h1 className="m-0">View Estimation</h1>
                     </div>
                     <div className="btnWrap">
                        <Link to="/estimate" className="btn addBtn">
                           {' '}
                           <ArrowBackIcon /> Back
                        </Link>
                     </div>
                  </div>
               </div>
            </div>
            <div className="card customCard p-3 m-3">
               {/* <div className="card-header">
          <h3 className="card-title">Estimation</h3>
        </div> */}
               {isLoadingForLead ||
               isLoadingForProvider ||
               isLoadingForEstimate ? (
                  <div>Loading...</div>
               ) : errorForLead || errorForProvider || errorForEstimate ? (
                  <div>
                     Error: {errorForLead?.message}
                     {errorForProvider?.message} {errorForEstimate?.message}
                  </div>
               ) : (
                  <Formik
                     initialValues={{
                        leadId: estimate?.response?.lead?.id,
                        serviceProviderId:
                           estimate?.response?.serviceProvider?.id,
                        name: estimate?.response?.name,
                        description: estimate?.response?.description,
                        revisionVersion: estimate?.response?.revisionVersion,
                        revisionComment: estimate?.response?.revisionComment,
                        totalHours: estimate?.response?.totalHours,
                        totalCost: estimate?.response?.totalCost,
                        techStack: estimate?.response?.techStack,
                        file: '',
                     }}
                     validationSchema={validationSchema}
                     onSubmit={(values) => handleSubmit(values)}
                  >
                     {({ values, setFieldValue, touched, errors }) => (
                        <Form>
                           <Box
                              className="card-body"
                              sx={{ padding: '15px 0' }}
                           >
                              <Grid container spacing={2}>
                                 <Grid item md={12} xs={12}>
                                    <Box>
                                       <Grid container spacing={2}>
                                          <Grid item md={6} xs={12}>
                                             {isLoadingForLead ? (
                                                <div>Loading...</div>
                                             ) : isErrorForLead ? (
                                                <div>
                                                   Error:{' '}
                                                   {errorForLead?.message}
                                                </div>
                                             ) : (
                                                <FormControl fullWidth>
                                                   <InputLabel
                                                      id="demo-select-small-label"
                                                      sx={
                                                         touched.leadId &&
                                                         Boolean(errors.leadId)
                                                            ? {
                                                                 color: 'hwb(353deg 2% 13%)',
                                                              }
                                                            : {}
                                                      }
                                                   >
                                                      Lead
                                                   </InputLabel>
                                                   <Field
                                                      label="Lead"
                                                      name="leadId"
                                                      as={Select}
                                                      disabled={true}
                                                      labelId="demo-select-small-lead"
                                                      id="demo-simple-select-lead"
                                                      onChange={(event) =>
                                                         setFieldValue(
                                                            'leadId',
                                                            event.target.value,
                                                         )
                                                      }
                                                      error={
                                                         touched.leadId &&
                                                         Boolean(errors.leadId)
                                                      }
                                                      helperText={
                                                         touched.leadId &&
                                                         errors.leadId
                                                      }
                                                   >
                                                      {leadData?.response?.map(
                                                         (val, index) => (
                                                            <MenuItem
                                                               key={index}
                                                               value={val.id}
                                                            >
                                                               {val.name}
                                                            </MenuItem>
                                                         ),
                                                      )}
                                                   </Field>
                                                   <ErrorMessage
                                                      name="leadId"
                                                      className="error-message"
                                                      component="div"
                                                      style={{ color: 'red' }}
                                                   />
                                                </FormControl>
                                             )}
                                          </Grid>

                                          <Grid item md={6} xs={12}>
                                             {isLoadingForProvider ? (
                                                <div>Loading...</div>
                                             ) : isErrorForProvider ? (
                                                <div>
                                                   Error:{' '}
                                                   {errorForProvider?.message}
                                                </div>
                                             ) : (
                                                <FormControl fullWidth>
                                                   <label htmlFor="serviceProviderId">
                                                      Service Provider
                                                   </label>
                                                   <InputLabel
                                                      id="demo-select-small-label"
                                                      sx={
                                                         touched.serviceProviderId &&
                                                         Boolean(
                                                            errors.serviceProviderId,
                                                         )
                                                            ? {
                                                                 color: 'hwb(353deg 2% 13%)',
                                                              }
                                                            : {}
                                                      }
                                                   >
                                                      Service Provider
                                                   </InputLabel>
                                                   <Field
                                                      label="Service Provider"
                                                      name="serviceProviderId"
                                                      as={Select}
                                                      disabled={true}
                                                      labelId="demo-select-small-label"
                                                      id="demo-simple-select"
                                                      onChange={(event) =>
                                                         setFieldValue(
                                                            'serviceProviderId',
                                                            event.target.value,
                                                         )
                                                      }
                                                      error={
                                                         touched.serviceProviderId &&
                                                         Boolean(
                                                            errors.serviceProviderId,
                                                         )
                                                      }
                                                      helperText={
                                                         touched.serviceProviderId &&
                                                         errors.serviceProviderId
                                                      }
                                                   >
                                                      {providerData?.response?.map(
                                                         (val, index) => (
                                                            <MenuItem
                                                               key={index}
                                                               value={val.id}
                                                            >
                                                               {val.name}
                                                            </MenuItem>
                                                         ),
                                                      )}
                                                   </Field>
                                                   <ErrorMessage
                                                      name="serviceProviderId"
                                                      className="error-message"
                                                      component="div"
                                                      style={{ color: 'red' }}
                                                   />
                                                </FormControl>
                                             )}
                                          </Grid>

                                          <Grid item md={6} xs={12}>
                                             <label htmlFor="name">Name</label>
                                             <Field
                                                fullWidth
                                                label="Name"
                                                name="name"
                                                variant="outlined"
                                                type="text"
                                                disabled={true}
                                                as={TextField}
                                                error={
                                                   touched.name &&
                                                   Boolean(errors.name)
                                                }
                                                helperText={
                                                   touched.name && errors.name
                                                }
                                             />
                                          </Grid>

                                          <Grid item md={6} xs={12}>
                                             <label htmlFor="revisionVersion">
                                                Revision Version
                                             </label>
                                             <Field
                                                fullWidth
                                                label="Revision Version"
                                                name="revisionVersion"
                                                variant="outlined"
                                                type="text"
                                                disabled={true}
                                                as={TextField}
                                                error={
                                                   touched.revisionVersion &&
                                                   Boolean(
                                                      errors.revisionVersion,
                                                   )
                                                }
                                                helperText={
                                                   touched.revisionVersion &&
                                                   errors.revisionVersion
                                                }
                                             />
                                          </Grid>

                                          <Grid item xs={12}>
                                             <Typography variant="subtitle1">
                                                Selected Technologies:
                                             </Typography>
                                             <Box>
                                                <Typography variant="body2">
                                                   {selectedTechnologies?.join(
                                                      ', ',
                                                   )}
                                                </Typography>
                                             </Box>
                                          </Grid>
                                          <Grid item md={6} xs={12}>
                                             <label htmlFor="totalhours">
                                                Total Hours
                                             </label>
                                             <Field
                                                fullWidth
                                                label="Total Hours"
                                                name="totalHours"
                                                variant="outlined"
                                                type="number"
                                                disabled={true}
                                                as={TextField}
                                                error={
                                                   touched.totalHours &&
                                                   Boolean(errors.totalHours)
                                                }
                                                helperText={
                                                   touched.totalHours &&
                                                   errors.totalHours
                                                }
                                             />
                                          </Grid>

                                          <Grid item md={6} xs={12}>
                                             <label htmlFor="totalcost">
                                                Total Cost
                                             </label>
                                             <Field
                                                fullWidth
                                                label="Total Cost"
                                                name="totalCost"
                                                variant="outlined"
                                                type="number"
                                                disabled={true}
                                                as={TextField}
                                                error={
                                                   touched.totalCost &&
                                                   Boolean(errors.totalCost)
                                                }
                                                helperText={
                                                   touched.totalCost &&
                                                   errors.totalCost
                                                }
                                             />
                                          </Grid>
                                          <Grid item xs={12}>
                                             <label htmlFor="revisioncommnet">
                                                Revision Comment
                                             </label>
                                             <Field
                                                fullWidth
                                                label="Revision Comment"
                                                name="revisionComment"
                                                variant="outlined"
                                                disabled={true}
                                                type="text"
                                                as={TextField}
                                                error={
                                                   touched.revisionComment &&
                                                   Boolean(
                                                      errors.revisionComment,
                                                   )
                                                }
                                                helperText={
                                                   touched.revisionComment &&
                                                   errors.revisionComment
                                                }
                                             />
                                          </Grid>

                                          <Grid item md={12} xs={12}>
                                             <Box>
                                                {/* <Typography variant="h6" gutterBottom align="center">
                                  Description
                                </Typography> */}
                                                <Grid container spacing={2}>
                                                   <Grid item xs={12}>
                                                      <Field name="description">
                                                         {({ field }) => (
                                                            <CKEditor
                                                               editor={
                                                                  ClassicEditor
                                                               }
                                                               data={
                                                                  field.value
                                                               }
                                                               disabled={true}
                                                            />
                                                         )}
                                                      </Field>
                                                      <ErrorMessage
                                                         name="description"
                                                         className="error-message"
                                                         component="div"
                                                      />
                                                   </Grid>
                                                </Grid>
                                             </Box>
                                          </Grid>
                                       </Grid>
                                    </Box>
                                 </Grid>
                              </Grid>
                           </Box>
                        </Form>
                     )}
                  </Formik>
               )}
            </div>
         </div>
      </StyledDashboardLayout>
   )
}
export default EstimateView
